import { Alert, Grid } from '@mui/material';
import { Doctor } from '../../../domain/entities';
import DoctorCard from './components/DoctorCard/DoctorCard';

interface Props {
  doctors: Doctor[];
  medicalCenter: string;
  selectedDate: Date;
  onScheduleSelected: (doctor: Doctor, schedule: Date) => void;
}

const DoctorCardGrid = ({ doctors, medicalCenter, selectedDate, onScheduleSelected }: Props) => {
  const firstHour = 8;
  const finalHour = 13;

  const startingDate = new Date(selectedDate.getTime());
  startingDate.setHours(firstHour, 0, 0);

  const schedules = [startingDate];
  const thirtyMinutes = 30 * 60 * 1000;

  for (let i = 1; i < (finalHour - firstHour) * 2; i++) {
    const otherDate = new Date(startingDate.getTime() + thirtyMinutes * i);
    schedules.push(otherDate);
  }

  const alert = (
    <Alert sx={{ margin: 1 }} severity='warning'>
      No se disponen de citas para la fecha y lugar seleccionados
    </Alert>
  );

  const grid = (
    <Grid container>
      {doctors.map((doctor) => (
        <Grid key={doctor.id} item p={1} xs={12} md={6} lg={4}>
          <DoctorCard
            key={doctor.id}
            doctor={doctor}
            medicalCenter={medicalCenter}
            schedules={schedules}
            onScheduleClicked={onScheduleSelected}
          />
        </Grid>
      ))}
    </Grid>
  );

  return doctors.length > 0 ? grid : alert;
};

export default DoctorCardGrid;
